import { render, staticRenderFns } from "./CompanyDetailsCard.vue?vue&type=template&id=4ed1dde0"
import script from "./CompanyDetailsCard.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports